import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=c82162e8&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82162e8",
  null
  
)

export default component.exports